export default "__VITE_ASSET__DJAbqoDL__"